import React from "react";
import Lottie from "lottie-react";
import LoadingAnimation from "./loading.json";

function Loader({ className }: { className?: string }) {
  return (
    <Lottie
      animationData={LoadingAnimation}
      loop={true}
      autoPlay
      rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
      style={{ width: 20, height: 20 }}
      className={className}
    ></Lottie>
  );
}

export default Loader;
